<template>
  <div id="contents">
    <div id="loader" v-if="op_fisrt_flag">
      <div id="loader_inner">
        <canvas id="loader_logo_s" width="88" height="88"></canvas>
        <p id="loader_logo"><img src="../assets/img/top/op_logo.png" width="411" alt="テレビ朝日映像" /></p>
      </div><!-- #loader_inner -->
    </div><!-- #loader -->

    <!-- <div v-if="recruit_logo_flag" id="recruit_2021_model">
      <div id="recruit_2021_image">
        <p class="title"><router-link v-bind:to="{name: 'recruit_2025'}" target="_blank"><img src="../assets/img/recruit/2025/model/recruit_title_logo.svg" width="434" alt="その熱量で、映像業界を駆け上がれ。RECRUIT 2025"/></router-link></p>
        <div id="recruit_2021_close_icon" class="recruit_2021_close_icon" ><img src="../assets/img/recruit/2025/model/close_icon.svg" alt="閉じるボタン" width="39" /></div>
        <p class="deco"><img src="../assets/img/recruit/2025/model/desc.svg" alt="2025年度新卒採用サイトを公開しました。" width="318" /></p>
        <p class="enter_btn">
          <router-link id="recruit_2021_enter_icon" v-bind:to="{name: 'recruit_2025'}" target="_blank">
            <img src="../assets/img/recruit/2025/model/enter_icon.svg" alt="RECRUIT 2025" width="175" />
          </router-link>
        </p>
      </div>
    </div> -->
    <!-- #recruit_2021_model -->

    <div v-if="notice_flag" id="notice_model">
      <div id="arikitarinakotobajyanakute">
        <div id="model_close_icon"><img src="../assets/img/recruit/2025/model/close_icon.svg" alt="閉じるボタン" width="39" /></div>
        <p class="thumb"><a href="https://arikitarinakotobajyanakute.com/" target="_blank"><img src="../assets/img/top/arikitarinakotobajyanakute_model.jpg" alt="ありきたりな言葉じゃなくて" width="850" /></a></p>
      </div>
    </div>
    <!-- #notice_model -->

    <div id="index">
      <p id="anchor_link" class="hover"><img src="../assets/img/top/top_bottom_arrow.png" width="65" alt="下矢印" /></p><!-- #anchor_link -->
      <div id="index_main">
        <div v-show="op_copy && op_fisrt_flag" id="index_op01" class="animated v_slower">
          <div id="index_op01_inner">
            <div id="index_op01_inner_copy">
              <h2><img src="../assets/img/top/op_play.png" width="697" alt="PLAY" /></h2>
              <p>挑んで、生み出して、高め合って、<br />今日も私たちは<span class="play">「ＰＬＡＹ」</span>する。<br />世の中に、&ldquo;真に面白い&rdquo;を届けるために。</p>
            </div>
          </div><!-- #index_op01_inner -->
        </div><!-- #index_op01 -->

        <p class="index_main_emphasis_img left_top"><a href="https://ark.tv-asahipro.co.jp/" target="_blank" rel="noopener"><img src="http://www.tv-asahipro.co.jp/wp-content/uploads/2021/07/streaming_studio_re.png" alt="Streaming Studio" width=""/></a></p>
        <!-- <p class="index_main_emphasis_img center_top"><a href="https://arikitarinakotobajyanakute.com/" target="_blank" rel="noopener"><img src="../assets/img/top/arikitarinakotobajyanakute.jpg" alt="ありきたりな言葉じゃなくて" width=""/></a></p> -->
        <p class="index_main_emphasis_img right_top"><a href="https://movie.tv-asahipro.co.jp/" target="_blank" rel="noopener"><img src="http://www.tv-asahipro.co.jp/wp-content/uploads/2021/04/service_banner.jpg" alt="動画制作サービス" width=""/></a></p>
        <div id="js-index_main_kv" class="index_main_kv_box">
          <div id="js-index_mainbox01" class="index_mainbox hoge01" v-if="slider_players">
            <p><router-link v-bind:to="{name: 'players_show', params: {id: slider_players[0].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_players[0].kv_image + ')' }"></router-link></p>
            <p><router-link v-bind:to="{name: 'players_show', params: {id: slider_players[1].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_players[1].kv_image + ')' }"></router-link></p>

            <p><router-link class="top_program_slider_item" v-bind:to="{name: 'works_program_show', params: {id: slider_program[0].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program[0].kv_image + ')' }"></router-link></p>
            <p><router-link class="top_program_slider_item" v-bind:to="{name: 'works_program_show', params: {id: slider_program[1].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program[1].kv_image + ')' }"></router-link></p>
            <p><router-link class="top_program_slider_item" v-bind:to="{name: 'works_program_show', params: {id: slider_program[2].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program[2].kv_image + ')' }"></router-link></p>
            <p><router-link class="top_program_slider_item" v-bind:to="{name: 'works_program_show', params: {id: slider_program[3].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program[3].kv_image + ')' }"></router-link></p>

            <p>
              <a v-if="this.external_link_url_check(slider_banner_latter_half[0].link)" v-bind:href="slider_banner_first_half[0].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner_first_half[0].image + ')' }"></a>
              <a v-else v-bind:href="slider_banner_first_half[0].link" target="_blank" rel="noopener" v-bind:style="{ backgroundImage: 'url(' + slider_banner_first_half[0].image + ')' }"></a>
            </p>
            <p>
              <a v-if="this.external_link_url_check(slider_banner_latter_half[1].link)" v-bind:href="slider_banner_first_half[1].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner_first_half[1].image + ')' }"></a>
              <a v-else v-bind:href="slider_banner_first_half[1].link" target="_blank" rel="noopener" v-bind:style="{ backgroundImage: 'url(' + slider_banner_first_half[1].image + ')' }"></a>
            </p>
            <p>
              <a v-if="this.external_link_url_check(slider_banner_latter_half[2].link)" v-bind:href="slider_banner_first_half[2].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner_first_half[2].image + ')' }"></a>
              <a v-else v-bind:href="slider_banner_first_half[2].link" target="_blank" rel="noopener" v-bind:style="{ backgroundImage: 'url(' + slider_banner_first_half[2].image + ')' }"></a>
            </p>

          </div><!-- .index_mainbox -->

          <div id="js-index_mainbox02" class="index_mainbox hoge02" v-if="slider_players">
            <p><router-link v-bind:to="{name: 'players_show', params: {id: slider_players[2].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_players[2].kv_image + ')' }"></router-link></p>
            <p><router-link v-bind:to="{name: 'players_show', params: {id: slider_players[3].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_players[3].kv_image + ')' }"></router-link></p>

            <p><router-link class="top_program_slider_item" v-bind:to="{name: 'works_program_show', params: {id: slider_program[4].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program[4].kv_image + ')' }"></router-link></p>
            <p><router-link class="top_program_slider_item" v-bind:to="{name: 'works_program_show', params: {id: slider_program[5].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program[5].kv_image + ')' }"></router-link></p>
            <p><router-link class="top_program_slider_item" v-bind:to="{name: 'works_program_show', params: {id: slider_program[6].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program[6].kv_image + ')' }"></router-link></p>
            <p><router-link class="top_program_slider_item" v-bind:to="{name: 'works_program_show', params: {id: slider_program[7].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program[7].kv_image + ')' }"></router-link></p>

            <p>
              <a v-if="this.external_link_url_check(slider_banner_latter_half[0].link)" v-bind:href="slider_banner_latter_half[0].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner_latter_half[0].image + ')' }"></a>
              <a v-else v-bind:href="slider_banner_latter_half[0].link" target="_blank" rel="noopener" v-bind:style="{ backgroundImage: 'url(' + slider_banner_latter_half[0].image + ')' }"></a>
            </p>
            <p>
              <a v-if="this.external_link_url_check(slider_banner_latter_half[1].link)" v-bind:href="slider_banner_latter_half[1].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner_latter_half[1].image + ')' }"></a>
              <a v-else v-bind:href="slider_banner_latter_half[1].link" target="_blank" rel="noopener" v-bind:style="{ backgroundImage: 'url(' + slider_banner_latter_half[1].image + ')' }"></a>
            </p>
            <p>
              <a v-if="this.external_link_url_check(slider_banner_latter_half[2].link)" v-bind:href="slider_banner_latter_half[2].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner_latter_half[2].image + ')' }"></a>
              <a v-else v-bind:href="slider_banner_latter_half[2].link" target="_blank" rel="noopener" v-bind:style="{ backgroundImage: 'url(' + slider_banner_latter_half[2].image + ')' }"></a>
            </p>

          </div><!-- .index_mainbox -->




          <!-- <div id="js-index_mainbox03" class="index_mainbox hoge03" v-if="slider_players02">
            <p><router-link v-bind:to="{name: 'players_show', params: {id: slider_players02[0].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_players02[0].kv_image + ')' }"></router-link></p>
            <p><router-link v-bind:to="{name: 'players_show', params: {id: slider_players02[1].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_players02[1].kv_image + ')' }"></router-link></p>

            <p><router-link v-bind:to="{name: 'works_program_show', params: {id: slider_program02[0].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program02[0].kv_image + ')' }"></router-link></p>
            <p><router-link v-bind:to="{name: 'works_program_show', params: {id: slider_program02[1].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program02[1].kv_image + ')' }"></router-link></p>
            <p><router-link v-bind:to="{name: 'works_program_show', params: {id: slider_program02[2].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program02[2].kv_image + ')' }"></router-link></p>
            <p><router-link v-bind:to="{name: 'works_program_show', params: {id: slider_program02[3].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program02[3].kv_image + ')' }"></router-link></p>

            <p><a v-bind:href="slider_banner02[0].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner02[0].image + ')' }"></a></p>
            <p><a v-bind:href="slider_banner02[1].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner02[1].image + ')' }"></a></p>
            <p><a v-bind:href="slider_banner02[2].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner02[2].image + ')' }"></a></p>

          </div> --><!-- .index_mainbox -->



          <!-- <div id="js-index_mainbox04" class="index_mainbox hoge04" v-if="slider_players02">
            <p><router-link v-bind:to="{name: 'players_show', params: {id: slider_players02[2].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_players02[2].kv_image + ')' }"></router-link></p>
            <p><router-link v-bind:to="{name: 'players_show', params: {id: slider_players02[3].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_players02[3].kv_image + ')' }"></router-link></p>

            <p><router-link v-bind:to="{name: 'works_program_show', params: {id: slider_program02[3].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program02[3].kv_image + ')' }"></router-link></p>
            <p><router-link v-bind:to="{name: 'works_program_show', params: {id: slider_program02[4].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program02[4].kv_image + ')' }"></router-link></p>
            <p><router-link v-bind:to="{name: 'works_program_show', params: {id: slider_program02[5].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program02[5].kv_image + ')' }"></router-link></p>
            <p><router-link v-bind:to="{name: 'works_program_show', params: {id: slider_program02[6].post_id}}" v-bind:style="{ backgroundImage: 'url(' + slider_program02[6].kv_image + ')' }"></router-link></p>

            <p><a v-bind:href="slider_banner02[3].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner02[3].image + ')' }"></a></p>
            <p><a v-bind:href="slider_banner02[4].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner02[4].image + ')' }"></a></p>
            <p><a v-bind:href="slider_banner02[5].link" v-bind:style="{ backgroundImage: 'url(' + slider_banner02[5].image + ')' }"></a></p>

          </div> --><!-- .index_mainbox -->




        </div><!-- #js-index_main_kv -->

        <!-- <p class="down_arrow"><img src="../assets/img/top/arrow_down.png" alt="down_arrow" width="35" /></p> -->
      </div><!-- #index_main -->

      <div id="index_copy" class="top_section">
        <h2><img src="../assets/img/top/copy.png" width="278" alt="PLAY" /></h2>
        <div id="index_copy_inner">
          <p>私たちが考える<span class="play">「ＰＬＡＹ」</span></p>
          <p>それは、挑戦して、生み出して、高め合って、</p>
          <p>何かに思いっきり打ち込むこと。</p>
          <p>テレビ朝日映像では、</p>
          <p>一人ひとりが楽しんで<span class="play">「ＰＬＡＹ」</span>を体現する</p>
          <p><span class="play">ＰＬＡＹｅｒ</span>として、</p>
          <p>世の中に&ldquo;真に面白い&rdquo;を届けています。</p>
        </div>
      </div>

      <div id="index_works" class="index_contents top_section" v-if="top_program_item">
        <h2 class="top_sec_title">
          <img src="../assets/img/top/works_title.png" width="210" alt="WORKS" />
          <span>制作実績</span>
        </h2><!-- .top_sec_title -->
        <div id="index_works_inner">
          <ul>
            <li v-for="program in top_program_item" :key="program.post_id"><router-link v-bind:to="{name: 'works_program_show', params: {id: program.post_id}}" class="hover"><img :src="program.kv_image" width="286" alt="番組のロゴ" /></router-link></li>
          </ul>
          <p class="top_read_more hover"><router-link v-bind:to="{name: 'program_index'}"><img src="../assets/img/top/read_more.png" width="146" alt="READ MORE" /></router-link></p>
        </div><!-- #index_works_inner -->
      </div><!-- #index_works -->


      <div id="index_players" class="index_contents top_section" v-if="top_players_item">
        <h2 class="top_sec_title">
          <img src="../assets/img/top/palyers_title.png" width="218" alt="PLAYers" />
          <span>社員紹介</span>
        </h2><!-- .top_sec_title -->
        <div id="index_players_inner">
          <!-- #以下、loop -->
          <div v-for="player in top_players_item" :key="player.post_id" class="player_card hover">
            <p class="player_index_image_main"><router-link v-bind:to="{name: 'players_show', params: {id: player.post_id}}" v-bind:style="{ backgroundImage: 'url(' + player.kv_image + ')' }"></router-link></p>
            <div class="player_card_inner">
              <h3>
                <router-link v-bind:to="{name: 'players_show', params: {id: player.post_id}}">
                  <span>{{player.name}}</span>
                  <span>{{player.staff_name_en}}</span>
                </router-link>
              </h3>
              <p class="player_num js-player_num" v-bind:data="player.staff_number"></p><!-- .player_num -->
            </div><!-- .player_card_inner -->
          </div><!-- .player_card -->
          <!-- #loopここまで -->

        </div><!-- #index_players_inner -->
        <p class="top_read_more hover"><router-link v-bind:to="{name: 'players_index'}"><img src="../assets/img/top/read_more.png" width="146" alt="READ MORE"/></router-link></p>
      </div><!-- #index_players -->

      <!-- <div id="index_ca" class="index_contents top_section" v-if="top_tapcast_item">
        <h2 class="top_sec_title">
          <img src="../assets/img/top/tap_cast_title.png" width="289" alt="TAP CAST" />
          <span>キャスティング・マネジメント</span>
        </h2>
        <div id="index_ca_inner">
          <ul>
            <li  v-for="tapcast in top_tapcast_item" :key="tapcast.post_id"><router-link v-bind:to="{name: 'tapcast_show', params: {id: tapcast.post_id}}" class="hover"><img :src="tapcast.single_main_image" width="367" alt="クリエイター写真" /></router-link></li>
          </ul>
        </div>
        <p class="top_read_more hover"><router-link v-bind:to="{name: 'tapcast_index'}"><img src="../assets/img/top/read_more.png" width="146" alt="READ MORE"/></router-link></p>
      </div> -->

      <div id="index_company" class="index_contents top_section">
        <h2 class="top_sec_title">
          <img src="../assets/img/top/company_title.png" width="279" alt="COMPANY" />
          <span>会社について</span>
        </h2><!-- .top_sec_title -->

        <div id="index_company_inner">
          <div class="index_company_message">
            <h3>ビジョン（ありたい姿）</h3>
            <p class="index_company_message_text">テレビ朝日グループの成長を牽引する<br />トップクリエイター集団</p>
          </div><!-- .index_company_message -->

          <div class="index_company_credo">
            <h3>行動指針</h3>
            <p>私たちは、世の中に感動を届ける、真に「面白い」ヒットコンテンツを創造し続けます。</p>
            <p>未体験を楽しみ、挑む、「冒険者」であろう！<br />アイデアで常識を覆す、「発明家」であろう！<br />個性を讃え、高め合う、「オーケストラ」であろう！<br />こだわりと責任に向き合う、「職人」であろう！</p>
          </div><!-- .index_company_message -->

          <p class="index_company_logo"><img src="../assets/img/top/company_logo.png" width="496" alt="テレビ朝日映像" /></p>

          <ul class="index_company_nav">
            <li><router-link v-bind:to="{ name : 'news_show', params : { id: 8048, referrer: 'index'}}" class="btn btn-white">ロゴについて</router-link></li>
            <li><router-link v-bind:to="{ name : 'company_index' }" class="btn btn-white">会社概要ページへ</router-link></li>
          </ul>
        </div><!-- #index_company_inner -->
      </div><!-- #index_company -->

      <div id="index_footer_bnr">
        <ul>
          <li class="hover">
            <router-link v-bind:to="{ name : 'drawn_index' }">
              <h3><img src="../assets/img/top/drawn_title.png" width="225" alt="DRONE" /><span>ドローン事業</span></h3>
            </router-link>
          </li>
          <li class="hover">
            <router-link v-bind:to="{name:'video-archive_index'}">
              <h3><img src="../assets/img/top/archive_title.png" width="295" alt="ARCHIVE" /><span>映像アーカイブ</span></h3>
            </router-link>
          </li>
        </ul>
      </div><!-- #index_footer_bnr -->

    </div><!-- #index -->
  </div><!-- #contents -->
</template>


<script src="../assets/javascript/vendor/anijs.js"></script>

<script>
export default {
  name: 'index',
  data(){
    return{
      api_slider_url: this.$parent.api_base_url+'/api/top/index.php',
      api_program_url: this.$parent.api_base_url+'/api/top/top_program.php',
      api_players_url: this.$parent.api_base_url+'/api/top/top_players.php',
      api_tapcast_url: this.$parent.api_base_url+'/api/top/top_tapcast.php',
      op_copy: true,
      loading: false,
      op_fisrt_flag: false,
      // op_fisrt_flag: this.$parent.op_movie,
      notice_flag: false,
      // notice_flag: this.$parent.op_movie,
      recruit_logo_flag: false,
      // recruit_logo_flag: this.$parent.op_movie,
      first_access_cookie: false,
      slider_players: null,
      slider_program: null,
      slider_tapcasts: null,
      slider_banner: null,
      slider_players02: null,
      slider_program02: null,
      slider_tapcasts02: null,
      slider_banner02: null,
      top_program_item: null,
      top_players_item: null,
      top_tapcast_item: null,
      top_kv_numbers: [0,1,2,3,4,5,6,7,8],
      top_fade_flag: null,
      number_image_src: [
        require("../assets/img/common/n_0.png"),
        require("../assets/img/common/n_1.png"),
        require("../assets/img/common/n_2.png"),
        require("../assets/img/common/n_3.png"),
        require("../assets/img/common/n_4.png"),
        require("../assets/img/common/n_5.png"),
        require("../assets/img/common/n_6.png"),
        require("../assets/img/common/n_7.png"),
        require("../assets/img/common/n_8.png"),
        require("../assets/img/common/n_9.png")
      ],
      anime_image_src: require("../assets/img/logo_anime_small.jpg"),
      error: null,
      slider_banner_first_half: null,
      slider_banner_latter_half: null,
    }
  },
  methods: {
    fetch_top_slider_item(){
      this.$axios
        .get(this.api_slider_url)
        .then(response => {
          this.slider_players = response.data.top_palyers_item
          this.slider_program = response.data.top_program_item
          this.slider_tapcasts = response.data.top_tapcasts_item
          this.slider_banner = response.data.top_slider_item

          var slider_list = response.data.top_slider_item
          for (let i = slider_list.length - 1; i >= 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [slider_list[i], slider_list[j]] = [slider_list[j], slider_list[i]];
          }
          var slider_list_low_probability = $.grep(slider_list,
            function(elem, index) {
              return (elem.link != 'https://www.tv-asahipro.co.jp/company/sustainability');
            }
          );
          var slider_list_high_probability = $.grep(slider_list,
            function(elem, index) {
              return (elem.link == 'https://www.tv-asahipro.co.jp/company/sustainability');
            }
          );
          this.slider_banner_first_half = slider_list_high_probability.concat(slider_list_low_probability.slice(0, Math.floor(slider_list_low_probability.length / 2)))
          this.slider_banner_latter_half = slider_list_high_probability.concat(slider_list_low_probability.slice(Math.floor(slider_list_low_probability.length / 2, slider_list_low_probability.length - 1)))
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.loading = false)
    },
    fetch_top_slider_item02(){
      this.$axios
        .get(this.api_slider_url)
        .then(response => {
          this.slider_players02 = response.data.top_palyers_item
          this.slider_program02 = response.data.top_program_item
          this.slider_tapcasts02 = response.data.top_tapcasts_item
          this.slider_banner02 = response.data.top_slider_item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.loading = false)
    },
    fetch_top_program(){
      this.$axios
        .get(this.api_program_url)
        .then(response => {
          this.top_program_item = response.data.item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.loading = false)
    },
    fetch_top_players(){
      this.$axios
        .get(this.api_players_url)
        .then(response => {
          this.top_players_item = response.data.item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.loading = false)
    },
    fetch_top_tapcast(){
      this.$axios
        .get(this.api_tapcast_url)
        .then(response => {
          this.top_tapcast_item = response.data.item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.loading = false)
    },
    loopSleep(_loopLimit,_interval, _mainFunc){
      var loopLimit = _loopLimit;
      var interval = _interval;
      var mainFunc = _mainFunc;
      var i = 0;
      var loopFunc = function () {
        var result = mainFunc(i);
        if (result === false) {
          return;
        }
        i = i + 1;
        if (i < loopLimit) {
          setTimeout(loopFunc, interval);
        }
      }
      loopFunc();
    },
    arrayShuffle(array){
      for(var i = array.length - 1; i > 0; i--){
        var r = Math.floor(Math.random() * (i + 1));
        var tmp = array[i];
        array[i] = array[r];
        array[r] = tmp;
      }
      return array;
    },
    DomShuffle($dom_wrapper,$dom_child){
      var dom_arr = [];
      $dom_child.each(function() {
        dom_arr.push($(this).html());
      });
      dom_arr.sort(function() {
        return Math.random() - Math.random();
      });
      $dom_wrapper.empty();
      for( var j = 0; j < dom_arr.length; j++) {
          $dom_wrapper.append('<p>' + dom_arr[j] + '</p>');
      }
    },
    addClassFadeNext(num){
      $('#js-index_main_kv div:last p').eq(num).addClass('fade');
      if($('#js-index_main_kv div:eq(0) p').eq(num).hasClass('next')){
        $('#js-index_main_kv div:eq(0) p').eq(num).removeClass('next')
      }
      setTimeout(function(){
        $('#js-index_main_kv div:eq(0) p').eq(num).addClass('next');
      },2000);
    },
    indexKvFader(){

      var fade_interval = 3000;
      var slider_count = 0;

      var dom_shuffle = this.DomShuffle;
      var indexKvFader_func = this.indexKvFader;

      var addClassFadeNext = this.addClassFadeNext

      var stock_number = null;

      var $last_block = $('#js-index_main_kv div:last');
      var top_kv_numbers = this.arrayShuffle(this.top_kv_numbers);
      this.loopSleep(this.top_kv_numbers.length,fade_interval,function(i){
        // console.log('実行だよ！'+i);

        if (stock_number != null){
          var next_num = stock_number;
          addClassFadeNext(next_num);
          var stock_number = null;
        } else {
          // 次に出るサムネがクリエイターズバンクか調べる
          if($('#js-index_main_kv div:eq(0) p').eq(top_kv_numbers[i]).find('a').attr('href') == "https://www.tv-asahipro.co.jp/company/sustainability"){
            // クリアエイターズバンクの場合
            var loop_flg = false
            for( var kv_num = 0; kv_num <= $('#js-index_main_kv div:last p').length -1; kv_num++) {
              if ( $('#js-index_main_kv div:last p').eq(kv_num).find('a').attr('href') == "https://www.tv-asahipro.co.jp/company/sustainability"){
                var next_num = kv_num
                if ($('#js-index_main_kv div:last p').eq(next_num).hasClass('fade')){
                  addClassFadeNext(top_kv_numbers[i]);
                } else {
                  if( top_kv_numbers[i] != next_num){
                    var stock_number = top_kv_numbers[i]
                  }
                  addClassFadeNext(next_num);
                }
              }
            }
          } else {
            // クリアエイターズバンクじゃない場合
            if($('#js-index_main_kv div:last p').eq(top_kv_numbers[i]).hasClass('fade')){
              if(top_kv_numbers.length == i + 1){
                for( var kv_num = 0; kv_num < $('#js-index_main_kv div:last p').length -1; kv_num++) {
                  if ( !$('#js-index_main_kv div:last p').eq(kv_num).hasClass('fade')){
                    var next_num = kv_num
                    addClassFadeNext(next_num);
                  }
                }
              } else {
                addClassFadeNext(top_kv_numbers[i + 1]);
              }
            } else {
              addClassFadeNext(top_kv_numbers[i]);
            }
          }
        }

        // 230425 昔の仕様
        // $('#js-index_main_kv div:last p').eq(top_kv_numbers[i]).addClass('fade');
        // if($('#js-index_main_kv div:eq(2) p').eq(top_kv_numbers[i]).hasClass('next')){
        //   $('#js-index_main_kv div:eq(2) p').eq(top_kv_numbers[i]).removeClass('next')
        // }
        // setTimeout(function(){
        //   $('#js-index_main_kv div:eq(2) p').eq(top_kv_numbers[i]).addClass('next');
        // },2000);
        // 230425 昔の仕様 end

        slider_count++;
        // if(slider_count == 19){
        //   fetch_top_slider_item()
        // }else if(slider_count == 37){
        //   fetch_top_slider_item02()
        //   slider_count = 0;
        // }
        console.log(i)
        if( i == 8 ){
          setTimeout(function(){
            // console.log('実行！'+slider_count);
            $last_block.addClass('hide_box');
            $.when(
              this.top_kv_numbers = [0,1,2,3,4,5,6,7,8],
              $last_block.prependTo('#js-index_main_kv')
            ).done(function(){
              var move_dom_id = $('#js-index_main_kv div:first').attr('id');
              console.log('move_dom_id'+move_dom_id)
              dom_shuffle($("#"+move_dom_id+""),$("#"+move_dom_id+" p"));
              $('#js-index_main_kv div:first p').each(function(){
                $(this).removeClass('fade');
              });
              indexKvFader_func();
            });
          },fade_interval);
        }//_fade_end
      });
    },//indexKvFader_end
    external_link_url_check(url){
      if(url.match(/www.tv-asahipro.co.jp/) || url.match(/http/) == null){
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.$emit('change_op_flag_end')
    $('#model_close_icon, #recruit_2021_close_icon').click(function(){
      $('body').removeClass('no_scroll');
      $('#notice_model, #recruit_2021_model').fadeOut(500);
      $('.top_section').each(function (i) {
        secTopArr[i] = $(this).offset().top;
      });
      anchor_scroll_func();
    })
    $('#js-noclick').click(function(){
      return false;
    })
    var anime_image = this.anime_image_src
    var ts = this
    this.fetch_top_slider_item()
    this.fetch_top_slider_item02()
    this.fetch_top_players()
    this.fetch_top_program()
    this.fetch_top_tapcast()

    //jquey
    var top_kv_numbers = [0,1,2,3,4,5,6,7,8];
    var fade_interval = 3000;

    var load_interval = 3000;
    var copy_interval = 2000;

    var arrayShuffle = this.arrayShuffle
    var loopSleep = this.loopSleep

    var fetch_top_slider_item = this.fetch_top_slider_item
    var fetch_top_slider_item02 = this.fetch_top_slider_item02



    var anchor_scroll_func = anchor_scroll;
    var pageTop = $('html, body');
    var secTopArr = new Array();
    var current = -1;

    //cookie
    var cookies = document.cookie;
    var cookiesArray = cookies.split(';');
    for(var c of cookiesArray){
      var cArray = c.split('=');
      if(cArray[0].indexOf("vivia_op_date") > -1 && cArray[1]){
        this.first_access_cookie = true;
      }
    }
    var now = new Date();
    var expires_date = new Date();
    expires_date.setDate(now.getDate() + 1);
    document.cookie = "vivia_op_date=" + encodeURIComponent(now) + ";expires=" + expires_date.toUTCString();

    if(this.notice_flag){
      //初回
      $('body').addClass('no_scroll');
      var queue = new createjs.LoadQueue(true);
      var manifest = [this.anime_image_src];
      queue.loadManifest(manifest,true);
      queue.addEventListener("complete",function(){
        // setTimeout(op_logo_anime(),800);
        $('#arikitarinakotobajyanakute').fadeIn(500);
      });
      $('#index_op01').remove()
      setTimeout(function(){
        $('body').removeClass('no_scroll');
        $('#notice_model, #recruit_2021_model').fadeOut(500);
        $('.top_section').each(function (i) {
          secTopArr[i] = $(this).offset().top;
        });
        anchor_scroll_func();
      },5000)
    } else if(this.recruit_logo_flag){
      //初回
      $('body').addClass('no_scroll');
      var queue = new createjs.LoadQueue(true);
      var manifest = [this.anime_image_src];
      queue.loadManifest(manifest,true);
      queue.addEventListener("complete",function(){
        setTimeout(op_logo_anime(),800);
      });
      $('#recruit_2021_model').fadeOut(500);
      $('#loader').show();
      $('#index_op01').remove()
      setTimeout(function(){
        $('#loader_logo').animate({
          width: '411px'
        }, 1200, 'swing',function(){
          setTimeout(function(){
            $('#loader').fadeOut(1200,function(){
              $('#loader').remove();
              ts.indexKvFader();
            })
          },1000)
          $('#recruit_2021_model').fadeIn(500);
        })
      },4400)
    } else if(this.op_fisrt_flag){
      //初回
      $('body').addClass('no_scroll');
      var queue = new createjs.LoadQueue(true);
      var manifest = [this.anime_image_src];
      queue.loadManifest(manifest,true);
      queue.addEventListener("complete",function(){
        setTimeout(op_logo_anime(),800);
      });

      $('#loader').show();
      setTimeout(function(){
        $('#loader_logo').animate({
          width: '411px'
        }, 1200, 'swing',function(){
          setTimeout(function(){
            $('#loader').fadeOut(1200,function(){
              $('#loader').remove();
              //fadeへ変更
              setTimeout(function(){
                $('#index_op01').fadeOut(600,function(){
                  $('body').removeClass('no_scroll');
                  $('.top_section').each(function (i) {
                    secTopArr[i] = $(this).offset().top;
                  });
                  ts.indexKvFader();
                  anchor_scroll_func();
                  $('#index_op01').remove()
                });
              },2000)


            })
          },1000)
        })
      },4400)
    }else{
      //op_済
      anchor_scroll_func();
      setTimeout(function(){
      ts.indexKvFader();
      },fade_interval);
    }


    function anchor_scroll(){
      $(window).on('scroll',function () {
        for (var i = secTopArr.length-1; i>=0; i--) {
          if ($(window).scrollTop() > secTopArr[i] - 100) {
            if ( i != current) {
              current = i;
            }
            break;
          }
        }
        if($(window).scrollTop() > secTopArr[4]){
          $('#anchor_link').fadeOut(500);
        }else{
          $('#anchor_link').fadeIn(500);
        }
      });
      $('#anchor_link').click(function(){
        console.log(current);
        $('body,html').animate({scrollTop: secTopArr[current + 1] - 20}, 800, 'swing',function(){
          if(current == 4){
            $('#anchor_link').hide();
          }
        });
      });
    }//anchor_scroll_end

    // function indexKvFader(flg){
    //   if(flg == null){ flg == false }
    //   if(flg){ return false }
    //
    //   var $last_block = $('#js-index_main_kv div:last');
    //   top_kv_numbers = arrayShuffle(top_kv_numbers);
    //   loopSleep(top_kv_numbers.length,fade_interval,function(i){
    //     // console.log('実行だよ！'+i);
    //     $('#js-index_main_kv div:last p').eq(top_kv_numbers[i]).addClass('fade');
    //     if($('#js-index_main_kv div:eq(2) p').eq(top_kv_numbers[i]).hasClass('next')){
    //       $('#js-index_main_kv div:eq(2) p').eq(top_kv_numbers[i]).removeClass('next')
    //     }
    //     setTimeout(function(){
    //       $('#js-index_main_kv div:eq(2) p').eq(top_kv_numbers[i]).addClass('next');
    //     },2000);
    //     slider_count++;
    //     // if(slider_count == 19){
    //     //   fetch_top_slider_item()
    //     // }else if(slider_count == 37){
    //     //   fetch_top_slider_item02()
    //     //   slider_count = 0;
    //     // }
    //     console.log(i)
    //     if( i == 8 ){
    //       setTimeout(function(){
    //         // console.log('実行！'+slider_count);
    //         $last_block.addClass('hide_box');
    //         $.when(
    //           top_kv_numbers = [0,1,2,3,4,5,6,7,8],
    //           $last_block.prependTo('#js-index_main_kv')
    //         ).done(function(){
    //           var move_dom_id = $('#js-index_main_kv div:first').attr('id');
    //           console.log('move_dom_id'+move_dom_id)
    //           dom_shuffle($("#"+move_dom_id+""),$("#"+move_dom_id+" p"));
    //           $('#js-index_main_kv div:first p').each(function(){
    //             $(this).removeClass('fade');
    //           });
    //           indexKvFader();
    //         });
    //       },fade_interval);
    //     }//_fade_end
    //   });
    // }//indexKvFader





    function op_logo_anime(){
      var canvas,stage,anime;

      var anime_frames = [];
      var anime_frames_count = [];
      var horizon_frames = 0;
      var vetical_frames = 0;

      for (var i = 0;i < 60;i++) {
        anime_frames_count.push(i)
        if(i % 6 == 0 && i != 0 ){
          vetical_frames++;
          horizon_frames = 0;
        }else{
          horizon_frames++;
        }
        anime_frames.push([(horizon_frames * 88),(vetical_frames * 88),88,88])
      }

      canvas = document.getElementById("loader_logo_s");
      stage = new createjs.Stage(canvas);

      setSpriteSheet();

      createjs.Ticker.setFPS(24);
      createjs.Ticker.timingMode = createjs.Ticker.RAF_SYNCHED;

      if (createjs.Touch.isSupported()) {
        createjs.Touch.enable(stage);
      }
      stage.update();

      function setSpriteSheet() {
        var image_data = {
          'images': [anime_image],
           'frames': anime_frames,
           'animations': {
             circle: {
               frames: anime_frames_count,
                speed: 1
             }
           }
         };
        var spritesheet = new createjs.SpriteSheet(image_data);
        anime = new createjs.Sprite(spritesheet, 'circle');
        Object.defineProperty(anime, "animationFrame", {
            get: function() {
                // console.log(this)
                return this.currentFrame;
            },
            set: function(frame) {
                this.gotoAndStop(Math.floor(frame));
                if(Math.floor(frame >= 59)){
                  this.stop();
                  createjs.Ticker.removeEventListener("tick", update);
                }
            }
        });
        stage.addChild(anime);
        createjs.Tween.get(anime).to({ animationFrame: 59 }, 4000, createjs.Ease.quadIn);
        createjs.Ticker.addEventListener("tick", update);
      }

      function update(event) {
          if(anime.currentFrame != 60 ){
            stage.update();
          }
      }
    }//op_logo_anime

  },
  updated (){
    var ts = this
    if(this.op_fisrt_flag){
     this.DomShuffle($("#js-index_mainbox01"),$("#js-index_mainbox01 p"));
     this.DomShuffle($("#js-index_mainbox02"),$("#js-index_mainbox02 p"));
    //  this.DomShuffle($("#js-index_mainbox03"),$("#js-index_mainbox03 p"));
    //  this.DomShuffle($("#js-index_mainbox04"),$("#js-index_mainbox04 p"));
    }
    //画像の置き換え_main
    var number_image_list = this.number_image_src
    $('.js-player_num').each(function(){
      replaceNumber($(this))
    });
    function replaceNumber($dom){
      $dom.html('');
      var staff_num = $dom.attr('data');
      staff_num = ('0000000000' + staff_num).slice(-3);
      $dom.append('<img src="'+number_image_list[staff_num.charAt(0)]+'">');
      $dom.append('<img src="'+number_image_list[staff_num.charAt(1)]+'">');
      $dom.append('<img src="'+number_image_list[staff_num.charAt(2)]+'">');
    }//replaceNumber
    this.$nextTick(function() {
      console.log('nextTick')
      setTimeout(function(){
        ts.$emit('page_fade')
      },1000)
    })
  },
  destroyed: function () {
    console.log('destory')
    $(window).off("scroll")
    $('body').removeClass('no_scroll');
    for(var i = 1; i < 1000; i++) {
      clearTimeout(i);
    }
  }//updated_end
}
</script>

<style lang="sass">
  #notice_model
    position: fixed
    top: 0px
    width: 100vw
    height: 100vh
    background: rgba(255,255,255,0.92)
    z-index: 1000
    #arikitarinakotobajyanakute
      display: none
      position: relative
      width: 850px
      height: 487px
      margin: calc(((100vh - 0px) - 487px) / 2) auto
      #model_close_icon
        position: absolute
        top: -49px
        right: 0px
        img
          margin: 0
          width: 39px
          height: 39px
          cursor: pointer
          transition: .3s all
          &:hover
            transform: scale(1.1)
  #recruit_2021_model
    position: fixed
    top: 63px
    width: 100vw
    height: 100vh
    background: rgba(255,255,255,0.92)
    z-index: 110
    #apology_link
      display: table
      margin: 2vh auto 0
      padding: 0 30px
      a
        display: block
        font-size: 22px
        font-weight: bold
        line-height: 1.8
        color: #fff
        transition: .3s all
        &:hover
          text-decoration: none
    #recruit_2021_image
      position: relative
      margin: calc(((100vh - 124px) - 544px) / 2)  auto
      width: 434px
      height: 544px
      @media(max-height: 768px)
        margin: calc(((100vh - 39px) - 544px) / 2) auto
        transform: scale(.7)
      p,a
        display: block
        line-height: 1
      .title
        margin: 0 auto 54px
        text-align: center
        transition: .3s all
        &:hover
          transform: scale(1.01)
      .deco
        margin: 0 auto 17px
        text-align: center
      .enter_btn
        width: 197px
        margin: 0 auto
        padding: 6px 0
        border: 2px solid #000
        background: #000
        text-align: center
        transition: .3s all
        &:hover
          background: #fff
          img
            filter: brightness(0) invert(0)
        img
          transition: .3s all
      #recruit_2021_close_icon
        position: absolute
        top: -37px
        right: -98px
        img
          margin: 0
          width: 39px
          height: 39px
          cursor: pointer
          transition: .3s all
          &:hover
            transform: scale(1.1)
      // #recruit_2021_enter_icon
      //   position: absolute
      //   top: 59.8vh
      //   left: calc((56.2vh - 30.2vh) / 2)
      //   width: 29.6vh
      //   height: 5.2vh
      //   border: 2px solid #000
      //   background-color: rgba(255,255,255,0)
      //   transition: .2s cubic-bezier(0.42, 0, 1.0, 1.0)
      //   .enter_btn
      //     // margin: calc((4.4vh - 0.85vh) / 2) calc((29.6vh - 6vh) / 2)
      //     width: 197px
      //     height: 48px
      //     cursor: pointer
      //     &:hover
      //       transform: scale(1.1)
      //   &:hover
      //     background-color: rgba(255,255,255,1)
      //     .enter_btn
      //       transform: scale(1.1)
</style>


// WEBPACK FOOTER //
// src/components/index.vue